import { render, staticRenderFns } from "./Song.vue?vue&type=template&id=f808ac74&scoped=true&"
import script from "./Song.vue?vue&type=script&lang=js&"
export * from "./Song.vue?vue&type=script&lang=js&"
import style0 from "./Song.vue?vue&type=style&index=0&id=f808ac74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f808ac74",
  null
  
)

component.options.__file = "Song.vue"
export default component.exports